import { HorizontalContainer } from '@picsart/design-system/components/HorizontalContainer';
import { useTranslator } from '@picsart/rc/services/localization';

import { Select, SelectItem, SelectSizesSM } from '@picsart/design-system/components/Select';
import { useEffect, useState } from 'react';
import classNames from 'classnames';
import { conversionFactors, SizeUnits } from './constants';

import { SizeCalculateProps } from './types';

import useStyles from './styles';

const SizeCalculate = ({ sizeData }: SizeCalculateProps) => {
  const classes = useStyles();
  const translate = useTranslator();

  const [values, setValues] = useState([]);
  const [originValues, setOriginValues] = useState([]);
  const [sizeTypes, setSizeTypes] = useState(SizeUnits.INCHES);

  const handleChange = type => {
    const multipliedValues = originValues.map(pair =>
      pair.map(num => (parseFloat(num) * conversionFactors[type]).toFixed(2)),
    );
    setValues(multipliedValues);
    setSizeTypes(type);
  };

  useEffect(() => {
    const extractedValues = sizeData?.map(item => item.value);
    const splitValues = extractedValues.map(item => {
      return item.split('x');
    });
    setValues(splitValues);
    setOriginValues(splitValues);
  }, [sizeData]);

  return (
    <HorizontalContainer className={classes.root}>
      <div className={classes.calculateHeader}>
        <div className={classes.headerCol2}>
          <h4>{translate('Format')}</h4>
        </div>
        <div className={classNames(classes.headerCol2, classes.flexCenter)}>
          <h4>{translate('Cover size')}</h4>
        </div>
        <div className={classNames(classes.headerCol1, classes.flexRight)}>
          <Select
            size={SelectSizesSM}
            label="in"
            className={classes.calculateSelect}
            onChange={handleChange}
          >
            <SelectItem value={SizeUnits.INCHES}>{SizeUnits.INCHES}</SelectItem>
            <SelectItem value={SizeUnits.CENTIMETERS}>{SizeUnits.CENTIMETERS}</SelectItem>
            <SelectItem value={SizeUnits.MILLIMETERS}>{SizeUnits.MILLIMETERS}</SelectItem>
            <SelectItem value={SizeUnits.PIXELS}>{SizeUnits.PIXELS}</SelectItem>
          </Select>
        </div>
      </div>
      <div className={classes.container}>
        <div className={classes.tableRow}>
          <div className={classes.headerCol2}>
            {sizeData?.map(item => (
              <div
                className={classNames(classes.headerColItem, classes.leftRadius)}
                key={item.name}
              >
                {item.name}
              </div>
            ))}
          </div>
          <div className={classNames(classes.headerCol2, classes.flexCenter)}>
            {values.map(item => (
              <div
                className={classes.headerColItem}
                key={item[0]}
              >{`${item[0]} x ${item[1]} ${sizeTypes}`}</div>
            ))}
          </div>
          <div className={classNames(classes.headerCol1)}>
            <div className={classNames(classes.rightRadius, classes.emptyItem)} />
            <div className={classNames(classes.rightRadius, classes.emptyItem)} />
            <div className={classNames(classes.rightRadius, classes.emptyItem)} />
          </div>
        </div>
      </div>
    </HorizontalContainer>
  );
};

export default SizeCalculate;
